import axios from 'axios';
import { createApp } from 'vue'

import Disclosure from '../components/Disclosure.vue'

const app = createApp(Disclosure);

app.mount('#company-disclosure-app');
